import React, { useState, useContext, useEffect, useRef } from "react";
import { useSpring, animated } from "react-spring";
import { useScreenTransition } from "../../Hooks/useScreenTransition";
import { AuthContext } from "../../Context/AuthContext";
import { TransitionContext } from "../../Context/TransitionContext";
import { NotificationContext } from "../../Context/NotificationContext";
import { languages } from "../../Data/languages";
import "./Quotes.css";
import { ReactComponent as SEARCHICON } from "../../assets/icons/search.svg";
import { ReactComponent as DOWN } from "../../assets/icons/filter-down.svg";
import { ReactComponent as UP } from "../../assets/icons/filter-up.svg";
import { ReactComponent as SORTBLACK } from "../../assets/icons/sort-black.svg";
import { ReactComponent as MORE } from "../../assets/icons/More.svg";
import { ReactComponent as MORESELECTED } from "../../assets/icons/More-selected.svg";
import { ReactComponent as MESSAGE } from "../../assets/icons/Message-icons.svg";
import { ReactComponent as STATUS } from "../../assets/icons/Status.svg";
import { ReactComponent as DATE } from "../../assets/icons/Date.svg";
import { ReactComponent as LANGUAGES } from "../../assets/icons/Languages.svg";
import { ReactComponent as SERVICES } from "../../assets/icons/Services.svg";
import { ReactComponent as EXPEDITED } from "../../assets/icons/order-expedited.svg";
import { ReactComponent as EXPEDITEDPLUS } from "../../assets/icons/expedited-plus.svg";
import { ReactComponent as HARDCOPY } from "../../assets/icons/order-hard-copy.svg";
import { ReactComponent as NOTRY } from "../../assets/icons/order-notry.svg";
import { ReactComponent as PLACEDBY } from "../../assets/icons/placed-by.svg";
import { ReactComponent as SORT_ASC } from "../../assets/icons/sort-asc.svg";
import { ReactComponent as SORT_DSC } from "../../assets/icons/sort-dsc.svg";
import AccountNavBar from "../../NewComponents/AccountNavBar";
import { DataContext } from "../../Context/DataContext";
import NoData from "../../NewComponents/NoData";
import SearchFilter from "./OrdersComponents/SearchFilter";
import LanguageFilter from "./OrdersComponents/LanguageFilter";
import DateFilter from "./OrdersComponents/DateFilter";
import PopUpModal from "../../NewComponents/PopUpModal";
import SendPaymentLinkPopUp from "../../NewComponents/SendPaymentLinkPopUp";
import { ReactComponent as CANCELQUOTE } from "../../assets/icons/cancel-quote.svg";
import { ReactComponent as QUOTESUCCESS } from "../../assets/icons/quote-success.svg";
import { v4 as uuidv4 } from "uuid";
import Clientsfilter from "./OrdersComponents/Clientsfilter";
import { QUOTESTATUS } from "../../Data/statuses";
import { decrTeamFreeExpedOrder, formatTotal, getDiscount, getShortOrderNo, getTotal } from "../../Data/Functions";
import { checkFetchAlgoliaData, firestore } from "../../firebase.config";
import { getCounter } from "../../Data/Functions/getCounter";
import MessageDot from "../../NewComponents/MessageDot";
import { Configure, Pagination, SearchBox, useHits, useInstantSearch, useSearchBox, useSortBy } from "react-instantsearch-hooks-web";
import OpenInvoiceModal from "../../NewComponents/OpenInvoiceModal";
import { ReactComponent as Trash } from "../../assets/icons/Trash.svg";
import { Link } from "react-router-dom";
import QueryFilters from "./OrdersComponents/QueryFilters";


export const sampleQuotesData = [
  {
  objectID: "1234567890",
  id: "1234567890",
  sample: true,
  certified: true,
  discount: 0,
  discountApplied: false,
  expedited: true,
  files: [{format: "application/pdf", name: "sample_file.pdf", ref: "SampleOrder/sample_file.pdf", size: 4911, timestamp: 1755902180834, type: "source", url: "https://firebasestorage.googleapis.com/v0/b/project-everbary.appspot.com/o/SampleOrder%2Fsample_file.pdf?alt=media&token=45353bbb-b20c-426c-9fcb-1ccd0260ddfc"}],
  generalNotes: "",
  hardCopy: false,
  hardCopyExtra: null,
  hardCopyStatus: null,
  languageFrom: "spanish",
  languageTo: "english",
  email: "kathryn@murphy .com",
  clientFirstName: "Juan",
  clientLastName: "Alvarado",
  firstName: "Kathryn",
  lastName: "Murphy ",
  name: "Kathryn Murphy ",
  notarization: false,
  notarizationStatus: null,
  notes: "",
  notified: false,  
  quoteNumber: 75095,
  pagesCount: "1",
  paypalOrderID: "paid",
  status: "ordered",
  teamId: "1234567890",
  timestamp: 1755902188277,
  type: "business",
  userID: "1234567890",
  userNotes: "",
  wordCount: 0,
},
{
  objectID: "1234567891",
  id: "1234567891",
  sample: true,
  certified: true,
  discount: 0,
  discountApplied: false,
  expedited: true,
  files: [{format: "application/pdf", name: "sample_file.pdf", ref: "SampleOrder/sample_file.pdf", size: 4911, timestamp: 1755902180834, type: "source", url: "https://firebasestorage.googleapis.com/v0/b/project-everbary.appspot.com/o/SampleOrder%2Fsample_file.pdf?alt=media&token=45353bbb-b20c-426c-9fcb-1ccd0260ddfc"}],
  generalNotes: "",
  hardCopy: false,
  notarization: true,
  hardCopyExtra: null,
  hardCopyStatus: null,
  languageFrom: "portugueseBrazil",
  languageTo: "english",
  email: "darlene@robertson.com",
  clientFirstName: "Felix",
  clientLastName: "Goncalves",
  firstName: "Darlene",
  lastName: "Robertson",
  name: "Darlene Robertson",
  notarizationStatus: null,
  notes: "",
  notified: false,  
  quoteNumber: 75096,
  pagesCount: "1",
  paypalOrderID: "paid",
  status: "ordered",
  teamId: "1234567890",
  timestamp: 1755902188277,
  type: "business",
  userID: "1234567890",
  userNotes: "",
  wordCount: 0,
},
{
  objectID: "1234567892",
  id: "1234567892",
  sample: true,
  certified: true,
  discount: 0,
  discountApplied: false,
  expedited: true,
  files: [{format: "application/pdf", name: "sample_file.pdf", ref: "SampleOrder/sample_file.pdf", size: 4911, timestamp: 1755902180834, type: "source", url: "https://firebasestorage.googleapis.com/v0/b/project-everbary.appspot.com/o/SampleOrder%2Fsample_file.pdf?alt=media&token=45353bbb-b20c-426c-9fcb-1ccd0260ddfc"}],
  generalNotes: "",
  hardCopy: true,
  hardCopyExtra: {
    method: "priority",
    country: "United States",
    signature: true,
  },
  hardCopyStatus: "pending",
  languageFrom: "albanian",
  languageTo: "english",
  email: "cameronus@williamson.com",
  clientFirstName: "Amelia",
  clientLastName: "Hoxha",
  firstName: "Cameronus",
  lastName: "Williamson",
  name: "Cameronus Williamson",
  notarization: true,
  notarizationStatus: null,
  notes: "",
  notified: false, 
  quoteNumber: 75097,
  pagesCount: "1",
  paypalOrderID: "paid",
  status: "in-review",
  teamId: "1234567890",
  timestamp: 1755902188277,
  type: "business",
  userID: "1234567890",
  userNotes: "",
  wordCount: 0,
},
]

const AccountQuotesComponent = ({ windowSize }) => {

  const { transitionTo } = useScreenTransition();

  const { setColor } = useContext(TransitionContext);
  const { showNotification } = useContext(NotificationContext);
  const { signedIn } = useContext(AuthContext);
  const { userData, teamData } = useContext(DataContext);

  const [moreOptions, setMoreOptions] = useState("");
  // const [showDetailModal, setShowDetailModal] = useState("");

  const [statusFilter, setStatusFilter] = useState("");
  const [servicesFilter, setServicesFilter] = useState([]);

  const [showFilter, setShowFilter] = useState("");

  const [filterStartTimestamp, setFilterStartTimestamp] = useState(null);
  const [filterEndTimestamp, setFilterEndTimestamp] = useState(null);
  const [selectedLanguageFilter, setSelectedLanguageFilter] = useState({
    languageFrom: "",
    languageTo: "",
  });
  const [datePeriod, setDatePeriod] = useState("custom");

  const [teamMembers, setTeamMembers] = useState([]);

  const [selectedMembers, setSelectedMembers] = useState([]);

  const [selectedCancelModal, setSelectedCancelModal] = useState("");
  const [cancelBtnText, setCancelBtnText] = useState("Cancel Quote");
  const [selectedSendPayment, setSelectedSendPayment] = useState("");
  const [selectedPayment, setSelectedPayment] = useState("");
  const [paylaterBtn, setPaylaterBtn] = useState("Pay Later");

  const [isLoading, setIsLoading] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState("");

  const [buttonText, setButtonText] = useState("");
  const [orderState, setOrderState] = useState("");
  const [hoveredQuoteId, setHoveredQuoteId] = useState(null);
  const [openInvoiceModal, setOpenInvoiceModal] = useState();

  const moreOptionsRef = useRef(null);

  let nextPointer = useRef();
  if (!nextPointer.current) nextPointer.current = null;


  useEffect(() => {
    setColor(true);
  }, [setColor]);

   const [localQuotes, setLocalQuotes] = useState([]);
  
    useEffect(()=> {
      if(!checkFetchAlgoliaData()){
        if(signedIn && userData.id){
          firestore.collection("quotes").where(userData.teamId ? "teamId" : "userID", "==", userData.teamId ?? userData.id).orderBy("timestamp", "desc").get()
          .then(qSnap => {
            if(qSnap.empty){
              return;
            }
  
            setLocalQuotes(qSnap.docs.map(doc => ({...doc.data(), objectID: doc.id})));
          })
        }
      }
  
    }, 
    [userData,teamData])


  useEffect(() => {
    if (signedIn && userData && userData.teamId) {

      firestore
        .collection("users")
        .where("teamId", "==", userData.teamId)
        .get()
        .then((qSnap) => {
          if (!qSnap.empty) {
            setTeamMembers(
              qSnap.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
            );
          }
        });
    }
  }, [signedIn, userData]);

  useEffect(() => {
    if (userData?.accountType) {
      setButtonText("Place Order");
      setOrderState("Paid");
    } else if (userData && teamData?.billingTerm === "case-by-case") {
      setButtonText("Place Order");
      setOrderState("Paid");
    } else {
      setButtonText("Place Order");
      setOrderState("Order Placed");
    }
  }, [userData, teamData]);

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (!event.target.closest('.hardCopyAddressIconWrap')) {
          setMoreOptions("");
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, []);

  const handleMouseEnter = (quoteId) => {
    setHoveredQuoteId(quoteId);
  };

  const handleMouseLeave = () => {
    setHoveredQuoteId(null);
  };

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);

    const splitted = date.toDateString().split(" ");

    return splitted[1] + " " + splitted[2] + ", " + splitted[3];
  };

  const getLanguage = (language) => {
    if (languages.find((lang) => lang.value === language)) {
      return languages.find((lang) => lang.value === language).label;
    } else {
      return "";
    }
  };

  const formatFilterDate = (date) => {
    return (
      date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear()
    );
  };

  const getSelectedDateText = () => {
    if (filterStartTimestamp) {
      if (filterEndTimestamp) {
        return (
          formatFilterDate(new Date(filterStartTimestamp)) +
          " - " +
          formatFilterDate(new Date(filterEndTimestamp))
        );
      } else {
        return (
          formatFilterDate(new Date(filterStartTimestamp)) +
          " - " +
          formatFilterDate(new Date())
        );
      }
    } else {
      return "Date";
    }
  };

  const getLanguageLabel = (value) => {
    const language = languages.find((l) => l.value === value);

    if (language) {
      return language.label;
    } else {
      return "";
    }
  };

  const getSelectedLanguage = () => {
    if (
      selectedLanguageFilter.languageFrom !== "" &&
      selectedLanguageFilter.languageTo !== ""
    ) {
      return (
        getLanguageLabel(selectedLanguageFilter.languageFrom) +
        " to " +
        getLanguageLabel(selectedLanguageFilter.languageTo)
      );
    } else {
      return "Languages";
    }
  };

  const checkAnyFilterSelected = () => {
    if (filterStartTimestamp) {
      return true;
    }
    if (filterEndTimestamp) {
      return true;
    }
    if (
      selectedLanguageFilter.languageFrom &&
      selectedLanguageFilter.languageTo
    ) {
      return true;
    }
    if (selectedMembers.length > 0) {
      return true;
    }
    if (servicesFilter.length > 0) {
      return true;
    }
    if (statusFilter !== "") {
      return true;
    }
    return false;
  };

  const handleCancelQuote = () => {
    setCancelBtnText("Cancelling...");


    firestore
      .collection("quotes")
      .doc(selectedCancelModal.id)
      .update({
        status: "cancelled",
      })
      .then(() => {
        setTimeout(() => {
          setCancelBtnText("Cancel Quote");
          setSelectedCancelModal("");
          refresh();
        }, 3000)

      });
  };

  const handlePay = (quote) => {
    if (userData && teamData) {
      if (teamData.billingTerm && teamData.billingTerm !== "case-by-case") {
        handlePlaceOrder(quote, "pay-later");
      } else {
        setSelectedPayment(quote);
      }
    } else {
      transitionTo(`/make-payment/quote/${quote.id}`);
    }
  };

  const handlePlaceOrder = async (quoteInfo, paypalID) => {
    setPaylaterBtn("Placing Order...");
    setIsLoading(true);

    const now = new Date();


    let orderNumber = 0;

    await getCounter("order").then((number) => {
        orderNumber = parseInt(number, 10);
      })
    .catch((error) => {
      
      //console.log(error);
    });

    if (orderNumber === 0) {
      showNotification(
        "Error",
        "An error ocurred while placing the order. Please, try again. If it persists, contact support.",
        "error"
      );
      setPaylaterBtn("Pay Later");
      return false;
    }

    // const addressID = uuidv4();
    const orderID = uuidv4();

    const hardCopyAddress = quoteInfo.hardCopy && quoteInfo.hardCopyExtra;

    const saveNewAddress =
      hardCopyAddress &&
      hardCopyAddress.newAddress &&
      hardCopyAddress.saveAddress;

    const address = hardCopyAddress.newAddress
      ? {
        id: hardCopyAddress.id,
        country: hardCopyAddress.country,
        addressName: hardCopyAddress.addressName,
        firstName: hardCopyAddress.firstName,
        lastName: hardCopyAddress.lastName,
        recipient: hardCopyAddress.firstName + " " + hardCopyAddress.lastName,
        region: hardCopyAddress.region,
        city: hardCopyAddress.city,
        zipCode: hardCopyAddress.zipCode,
        street: hardCopyAddress.street,
        apartment: hardCopyAddress.apartment,
      }
      : signedIn &&
      userData &&
      userData.shipping &&
      userData.shipping.length > 0 &&
      userData.shipping.find((a) => a.id === hardCopyAddress.id);

    const saveNewAddressData = saveNewAddress ? address : "";

    firestore
      .collection("orders")
      .doc(orderID)
      .set({
        orderNumber: orderNumber,
        userID: quoteInfo.userID,
        email: quoteInfo.email,
        name: quoteInfo.name,
        certified: quoteInfo.certified,
        languageFrom: quoteInfo.languageFrom,
        languageTo: quoteInfo.languageTo,
        notarization: quoteInfo.notarization,
        notarizationStatus: quoteInfo.notarization ? "pending" : null,
        expedited: quoteInfo.expedited,
        hardCopy: quoteInfo.hardCopy,
        hardCopyStatus: quoteInfo.hardCopy ? "pending" : null,
        hardCopyExtra:
          quoteInfo.hardCopy && quoteInfo.hardCopyExtra
            ? quoteInfo.hardCopyExtra
            : null,
        pagesCount: quoteInfo.certified ? quoteInfo.pagesCount : 0,
        wordCount: !quoteInfo.certified ? quoteInfo.wordCount : 0,
        notes: quoteInfo.notes,
        files: quoteInfo.files,
        timestamp: now.getTime(),
        status: "new",
        shippingInfo: hardCopyAddress ? address : null,
        paypalOrderID: paypalID,
        discountApplied: quoteInfo.discount && quoteInfo.discount > 0,
        discount:
          quoteInfo.discount && quoteInfo.discount > 0 ? quoteInfo.discount : 0,
        teamId: userData.teamId || "",
        totalPrice: getTotal(quoteInfo),
        translatorCertification: quoteInfo.translatorCertification || "",

      })
      .then(async () => {
        await firestore.collection("quotes").doc(quoteInfo.id).update({
          status: "ordered",
          orderNumber: orderNumber,
          orderID: orderID,
        });
        if (signedIn && userData && saveNewAddress) {
          handleSaveNewAddress(saveNewAddressData);
        }

        if(quoteInfo.expedited || quoteInfo.expeditedPlus){
          decrTeamFreeExpedOrder(quoteInfo.teamId);
        }

        setPaylaterBtn("Pay Later");
        setIsLoading(false);
        setShowSuccessModal(quoteInfo.id);
        refresh();
      })
      .catch((error) => {
        //console.log(error);
        setIsLoading(false);
        setPaylaterBtn("Pay Later");
        showNotification(
          "Error",
          "An error ocurred while placing the order. Please, try again.",
          "error"
        );
      });
  };

  

  const handleSaveNewAddress = async (address) => {
    if (address) {

      const newAddress = { default: false, ...address };

      const mShipping = userData.teamId && teamData ? teamData.shipping ? teamData.shipping.concat([newAddress]) : [newAddress] 
      : userData.shipping ? userData.shipping.concat([newAddress]) : [newAddress];

      await firestore
        .collection(userData.teamId && teamData ? "teams" :"users")
        .doc(userData.teamId && teamData ? userData.id : userData.id)
        .update({
          shipping: mShipping,
        })
        .then(() => { })
        .catch((error) => {
          showNotification(
            "Error",
            "An error ocurred while saving the address. Unfortunately, the address couldn't be saved.",
            "error"
          );
        });
    }
  };

  const handlePopUpClick = (e) => {
    if (signedIn) {
      transitionTo(`/account/quote/${showSuccessModal}`, e);
      return setShowSuccessModal("");
    } else {
      transitionTo("/", e);
      return setShowSuccessModal("");
    }
  };

  const statusOverlayProps = useSpring({
    display: isLoading ? "flex" : "none",
  });

const {hits} = useHits();
const {status, refresh} = useInstantSearch();
const {query} = useSearchBox();
const [loading, setLoading] = useState(true);
const [showDetailModal, setShowDetailModal] = useState("");


const items = [
    {
    Label: "Default",
    value: "quotes"
    },
    {
    Label: "Date asc",
    value: "quote_time_asc"
    },
    {
    Label: "Date dsc",
    value: "quote_time_dsc"
    },
    {
    Label: "Name asc",
    value: "quote_name_asc"
    },
    {
    Label: "Name dsc",
    value: "quote_name_dsc"
    },
    {
    Label: "Client asc",
    value: "quote_client_asc"
    },
    {
    Label: "Client dsc",
    value: "quote_client_dsc"
    },
    {
    Label: "Status asc",
    value: "quote_status_asc"
    },
    {
    Label: "Status dsc",
    value: "quote_status_dsc"
    },
]
const { currentRefinement, refine } = useSortBy({items: items, defaultRefinement: "quote_time_dsc"});

useEffect(() => {
    if(status === "loading" || status === "stalled"){
    setLoading(true);
    }else{
    setLoading(false);
    }
}, [status])

useEffect(() => {
    if(currentRefinement === "quotes"){
    refine("quote_time_dsc");
    }
}, [currentRefinement])


  const [filters, setFilters] = useState(`userID: ${userData ? userData.id : "no-user"}`);
  
  useEffect(() => {
    const defalutFilters = userData && userData.teamId ? `teamId: ${userData.teamId}`: `userID: ${userData ? userData.id : "no-user"}`;
    let tempFilters = defalutFilters;
    
    if(filterStartTimestamp && filterEndTimestamp){
      tempFilters += ` AND timestamp >= ${filterStartTimestamp} AND timestamp <= ${filterEndTimestamp}`
    }
    if(selectedLanguageFilter && selectedLanguageFilter.languageFrom && selectedLanguageFilter.languageTo){
      tempFilters += ` AND languageFrom:${selectedLanguageFilter.languageFrom} AND languageTo:${selectedLanguageFilter.languageTo}`;
    }
    if(selectedMembers.length > 0){
      selectedMembers.forEach((email, i) => {tempFilters +=` ${i === 0 ? "AND" : "OR"} email:${email}`});
    }
    if (servicesFilter.includes("notry")){
        tempFilters+= ` AND notarization:true`;
     }
    if (servicesFilter.includes("expedited")){
        tempFilters += ` AND expedited:true`;
    }
    if (servicesFilter.includes("expedited+")){
        tempFilters += ` AND expeditedPlus:true`;
    }
    if (servicesFilter.includes("hardCopy")){
        tempFilters+= ` AND hardCopy:true`;
    }
    if(statusFilter){
      tempFilters+= ` AND status:${statusFilter}`;
    }

    if((tempFilters === `teamId: ${userData.teamId}` || tempFilters === `userID: ${userData ? userData.id : "no-user"}`) && query === ""){
      if(!checkFetchAlgoliaData() ? localQuotes.length === 0 : hits.length === 0){
        setShowSampleQuotes(true);
      }else{
        setShowSampleQuotes(false);
      }
    }else{
      setShowSampleQuotes(false);
    }

    setFilters(tempFilters);
  }
  , [filterStartTimestamp, filterEndTimestamp, userData, selectedMembers, selectedLanguageFilter, servicesFilter, statusFilter])

  const handleShowMore = (value) => {
    setShowFilter("");
    setMoreOptions(value);
  }

  const [showSampleQuotes, setShowSampleQuotes] = useState(true);
    
    
  const [sampleQuotes, setSampleQuotes] = useState(null);
  useEffect(() => {
    if(hits.length === 0){
      const sampleQuotes = JSON.parse(localStorage.getItem("sampleQuotes"));
      if(!sampleQuotes){
        localStorage.setItem("sampleQuotes", JSON.stringify(sampleQuotesData));
      }
      setSampleQuotes(sampleQuotes);
    }
  }, [hits]);

  const onClickSampleDelete = (quote)=> {
    const q = sampleQuotes.filter(q => q.objectID !== quote.objectID);
    localStorage.setItem("sampleQuotes", JSON.stringify(q));
    setSampleQuotes(q);
  }


  const TableDataComponent = ({hits }) => {
  
      // if(hits.length === 0){
      //   return <tbody></tbody>;
      // }
      const quotes = hits.length === 0 && showSampleQuotes ? sampleQuotes || [] : hits;
  
      return (
        <tbody>
        {quotes.map(hit =>
        {
          const quote = {...hit, id: hit.objectID}
          return (
              <tr key={quote.id} onClick={(e) => transitionTo(`/account/quote/${quote.id}`, e)}>
              {quote.sample ? <td className="quotewidth accountDetailsLink text-[#9A9FA7]">Sample</td> : ""}

                <td>
                  <Link to={`/account/quote/${quote.id}`} onClick={(e) => e.stopPropagation()}>
                      {quote.quoteNumber && quote.quoteNumber.toString().length > 12 &&
                        showDetailModal === quote.quoteNumber && (
                          <div className="accountdetailHoverBox">
                            <p
                              className="quotewidth "
                            >
                              {quote.quoteNumber}
                            </p>
                          </div>
                        )}
                    <p className="quotewidth accountDetailsLink" 
                      onMouseOver={() =>
                        setShowDetailModal(
                          quote.quoteNumber
                        )
                      }
                      onMouseLeave={() => setShowDetailModal("")}>
                      {getShortOrderNo(quote.quoteNumber, "quote")}
                    </p>
                  </Link>
                </td>
                <td>
                  <Link to={`/account/quote/${quote.id}`} onClick={(e) => e.stopPropagation()}>
                    <p className="quotewidth ">
                      {formatDate(quote.timestamp)}
                    </p>
                  </Link>
                </td>
                <td>
                  <Link to={`/account/quote/${quote.id}`} onClick={(e) => e.stopPropagation()}>
                    {showDetailModal ===
                      quote.id + quote.languageFrom && (
                        <div className="accountdetailHoverBox">
                          <p
                            className="quotewidth captialLetters"
                          >
                            {getLanguage(quote.languageFrom) +
                              " / " +
                              getLanguage(quote.languageTo)}
                          </p>
                        </div>
                      )}
                    <p
                      className="quotewidth"
                      style={{
                        textTransform: "uppercase",
                        cursor: "pointer",
                      }}
                      onMouseOver={() =>
                        setShowDetailModal(
                          quote.id + quote.languageFrom
                        )
                      }
                      onMouseLeave={() => setShowDetailModal("")}
                    >
                      {getLanguage(quote.languageFrom).substr(0, 2) +
                        "/" +
                        getLanguage(quote.languageTo).substr(0, 2)}
                    </p>
                  </Link>
                </td>
                {userData && userData.teamId && (
                  <td>
                  <Link to={`/account/quote/${quote.id}`} onClick={(e) => e.stopPropagation()}>
                    {quote.name.length > 15 &&
                      showDetailModal === quote.id + quote.name && (
                        <div className="accountdetailHoverBox">
                          <p
                            className="quotewidth captialLetters"
                          >
                            {quote.name}
                          </p>
                        </div>
                      )}
                    <p 
                      className="quotewidth captialLetters overflowText"
                      style={{ cursor: "pointer" }}
                      onMouseOver={() =>
                        setShowDetailModal(quote.id + quote.name)
                      }
                      onMouseLeave={() => setShowDetailModal("")}
                    >
                      {quote.name}
                    </p>
                  </Link>
                  </td>
                )}

                {userData && userData.teamId && (
                  <td>
                  <Link to={`/account/quote/${quote.id}`} onClick={(e) => e.stopPropagation()}>
                    {quote.clientFirstName ? (
                      <>
                        {(quote.clientLastName ? quote.clientFirstName + " " + quote.clientLastName : quote.clientFirstName).length > 14  
                        && showDetailModal === quote.id + "client" && (
                          <div className="accountdetailHoverBox">
                            <p className="quotewidth captialLetters">
                              {quote.clientFirstName || ""} {quote.clientLastName || ""}
                            </p>
                          </div>
                        )}
                        <p
                          className="quotewidth captialLetters overflowText"
                          style={{ cursor: "pointer" }}
                          onMouseOver={() => setShowDetailModal(quote.id + "client")}
                          onMouseLeave={() => setShowDetailModal("")}
                        >
                          {quote.clientFirstName || ""} {quote.clientLastName || ""}
                        </p>
                      </>
                    ) : (
                      <p className="quotewidth">-</p>
                    )}
                    </Link>
                  </td>

                )}

                <td>
                  <Link to={`/account/quote/${quote.id}`} onClick={(e) => e.stopPropagation()}>
                    {showDetailModal === quote.id + "N" && (
                      <div className="accountdetailHoverBox">
                        <p
                          className="quotewidth captialLetters"
                        >
                          Notarization
                        </p>
                      </div>
                    )}
                    {showDetailModal === quote.id + "E" && (
                      <div className="accountdetailHoverBox">
                        <p
                          className="quotewidth captialLetters"
                        >
                          {quote.expeditedPlus
                            ? "Expedited+ Turnaround"
                            : "Expedited Turnaround"}
                        </p>
                      </div>
                    )}
                    {showDetailModal === quote.id + "H" && (
                      <div className="accountdetailHoverBox">
                        <p
                          className="quotewidth captialLetters"
                        >
                          Mail Hard Copy
                        </p>
                      </div>
                    )}
                    <p className="quotewidth captialLetters flex gap-1">
                      <p className="opacity-0">.</p>
                      {quote.notarization && (
                        <NOTRY
                          style={{ cursor: "pointer" }}
                          onMouseOver={() =>
                            setShowDetailModal(quote.id + "N")
                          }
                          onMouseLeave={() => setShowDetailModal("")}
                        />
                      )}
                      {quote.expedited && (
                        <EXPEDITED
                          style={{ cursor: "pointer" }}
                          onMouseOver={() =>
                            setShowDetailModal(quote.id + "E")
                          }
                          onMouseLeave={() => setShowDetailModal("")}
                        />
                      )}
                      {quote.expeditedPlus && (
                        <EXPEDITEDPLUS
                          style={{ cursor: "pointer" }}
                          onMouseOver={() =>
                            setShowDetailModal(quote.id + "E")
                          }
                          onMouseLeave={() => setShowDetailModal("")}
                        />
                      )}
                      {quote.hardCopy ? (
                        <HARDCOPY
                          style={{ cursor: "pointer" }}
                          onMouseOver={() =>
                            setShowDetailModal(quote.id + "H")
                          }
                          onMouseLeave={() => setShowDetailModal("")}
                        />
                      ) : (
                        ""
                      )}
                    </p>
                  </Link>
                </td>
                <td>
                  <Link to={`/account/quote/${quote.id}`} onClick={(e) => e.stopPropagation()}>
                    {quote.sample ? <div className="chatDot" style={{backgroundColor: "#18b7bb"}}></div>
                      : <MessageDot chatId={quote.generalChatId}/>}
                    {/* <FileCommentIndicator orderId={quote.id} /> */}
                  </Link>
                </td>
                <td>
                  <Link to={`/account/quote/${quote.id}`} onClick={(e) => e.stopPropagation()}>
                    <p
                      className="quotewidth accountDetailsStatus"
                      style={{
                        backgroundColor: QUOTESTATUS[quote.status]
                          ? QUOTESTATUS[quote.status][1]
                          : "",
                      }}
                    >
                      {QUOTESTATUS[quote.status]
                        ? QUOTESTATUS[quote.status][0]
                        : ""}
                    </p>
                  </Link>
                </td>
                <td>
                  <Link to={`/account/quote/${quote.id}`} onClick={(e) => e.stopPropagation()}>
                    <p className="quotewidth">
                      { formatTotal( getTotal(quote) - getDiscount(quote))}
                    </p>
                  </Link>
                </td>
                <td  className="replied">
                  {quote.status === "replied" ? (
                    <>
                      {/* <p className="quotewidth">
                  <button
                    className="accountOrderBtn"
                    onClick={() => handlePay(quote)}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                  >
                    {buttonText}
                  </button>
                </p> */}
                {quote.sample ? <p className="quotewidth">-</p> : 
                      <p className="quotewidth">
                        <button
                          className="accountOrderBtn w-32 py-2 px-4 text-center transition-all duration-200"
                          onClick={(e) => {e.stopPropagation(); handlePay(quote)}}
                          onMouseEnter={() =>
                            handleMouseEnter(quote.id)
                          }
                          onMouseLeave={handleMouseLeave}
                        >
                          {hoveredQuoteId === quote.id &&
                            buttonText === "Place Order"
                            ? "Pay"
                            : buttonText}
                        </button>
                      </p>
                    }
                    </>
                  ) : (
                    <p
                      onClick={(e) =>
                        transitionTo(
                          `/account/quote/${quote.id}`,
                          e
                        )
                      }
                      className="quotewidth "
                    >
                      {quote.status === "ordered"
                        ? orderState
                        : quote.status === "cancelled"
                          ? "Cancelled"
                          : "-"}
                    </p>
                  )}
                </td>
                <td onClick={(e) => e.stopPropagation()}>
                {quote.sample ?
                  <Trash onClick={() => onClickSampleDelete(quote)}/>
                 : (quote.status === "submitted" ||
                  quote.status === "replied") && (
                      <div
                        className="hardCopyAddressIconWrap"
                        ref={moreOptionsRef}
                      tabIndex={0} // Enables blur event for accessibility
                      onBlur={() => setMoreOptions("")}
                      >
                        {moreOptions === quote.id ? (
                          <MORESELECTED
                            className="hardCopyAddressIcon"
                            onClick={(e) => {
                            e.stopPropagation(); // Prevents event bubbling
                            handleShowMore("");
                      }}
                          />
                        ) : (
                          <MORE
                            className="hardCopyAddressIcon"
                            onClick={(e) => {
                            e.stopPropagation(); // Prevents event bubbling
                            handleShowMore(quote.id);
                          }}
                          />
                        )}

                        {moreOptions === quote.id && (
                          <div className="hardCopyAddressEditWrap">
                            {
                              <div
                                className="hardCopyAddressEdit"
                                onClick={() => {
                                  setSelectedCancelModal({
                                    id: quote.id,
                                    quoteNumber: quote.quoteNumber,
                                  });                                    
                                }}
                              >
                                Cancel Quote
                              </div>
                            }
                            {signedIn &&
                              userData &&
                              quote.status === "replied" && (
                                <div
                                  className="hardCopyAddressEdit"
                                  onClick={() => {
                                    setSelectedSendPayment(quote);
                                    setMoreOptions("");
                                  }}
                                >
                                  Send Payment Link
                                </div>
                              )}
                          </div>
                        )}
                      </div>
                      
                    )}
                  </td>
              </tr>)
        })}
      </tbody>
      )
    }


return (
    <>
      <Configure filters={filters} hitsPerPage={20}/>
    {openInvoiceModal && <OpenInvoiceModal type="invoice" order={openInvoiceModal} onClose={() => setOpenInvoiceModal(null)}/>}
    
    <QueryFilters
        setFilterStartTimestamp={setFilterStartTimestamp}
        filterStartTimestamp={filterStartTimestamp}
        setFilterEndTimestamp={setFilterEndTimestamp}
        filterEndTimestamp={filterEndTimestamp}
        setDatePeriod={setDatePeriod}
        datePeriod={datePeriod}
        setStatusFilter={setStatusFilter}
        statusFilter={statusFilter}
        setServicesFilter={setServicesFilter}
        servicesFilter={servicesFilter}
        setSelectedMembers={setSelectedMembers}
        selectedMembers={selectedMembers}
        setSelectedLanguageFilter={setSelectedLanguageFilter}
        selectedLanguageFilter={selectedLanguageFilter}
        baseUrl="/account/quotes"
      />
    
     <animated.div
        style={statusOverlayProps}
        className="checkoutStatusOverlay"
      >
        We are finishing up. Please wait, this will take a second<span className="dotsLoading">...</span>
      </animated.div>
      {selectedPayment && (
        <PopUpModal
          title={"Create Order From The Quote"}
          backBtnText={paylaterBtn}
          subText={"Quote Number: #"+selectedPayment.quoteNumber}
          text={"Do you want to pay for the newly created order now or later?"}
          btnText={"Pay Now"}
          hideIcon
          showClose
          onClose={() => setSelectedPayment("")}
          onClick={(e) =>
            transitionTo(`/make-payment/quote/${selectedPayment.id}`, e)
          }
          onBackClick={() => {
            handlePlaceOrder(selectedPayment, "pay-later");
          }}
          disableBtn={paylaterBtn === "Placing Order..."}
        ></PopUpModal>
      )}
      {selectedCancelModal !== "" && (
        <PopUpModal
          title={"Cancel Quote"}
          backBtnText="Back to Quotes"
          subText="Are you sure you want to cancel this quote?"
          text={(selectedCancelModal.quoteNumber)}
          btnText={cancelBtnText}
          iconBgColor="#FFF6EA"
          deleteBtn={true}
          showClose
          onClose={() => setSelectedCancelModal("")}
          onClick={() => handleCancelQuote()}
          onBackClick={() => {
            setSelectedCancelModal("");
          }}
          disableBtn={cancelBtnText === "Cancelling..."}
        >
          <CANCELQUOTE />
        </PopUpModal>
      )}
      {showSuccessModal && (
        <PopUpModal
          title="Quota has been converted into the order"
          btnText="Ok"
          onClick={(e) => handlePopUpClick(e)}
          text="You can track the status of the order on the orders page in your account"
        >
          {<QUOTESUCCESS />}
        </PopUpModal>
      )}

      {selectedSendPayment !== "" && (
        <SendPaymentLinkPopUp
          data={selectedSendPayment}
          type="quote"
          id={selectedSendPayment.id}
          onClose={() => setSelectedSendPayment("")}
        />
      )}
    
    <AccountNavBar
    windowSize={windowSize}
    selectedTab="quotes"
    accountMainPadding={false}
    >
    <div className="accountMainTitleRow px-5 pt-5">
        <h2 className="accountMainTitle">Quotes</h2>
        
        <SearchBox classNames={{
        root: "newSearchbox",
        form: "newSearchbox_form",
        input: "newSearchbox_input",
        reset: "hidden",
        loadingIndicator: "hidden",
        }} 
        placeholder="Search By ID, Client or Request By" 
        submitIconComponent={() => <SEARCHICON/>} />
    </div>

    <div
        className={`grid grid-cols-2 ${teamData
            ? " xl:grid-cols-5 lg:grid-cols-4 md:grid-cols-2  xl:w-fit md:w-full "
            : " md:grid-cols-4 md:w-fit"
            } justify-center items-center gap-3 px-4  w-full`}
        >
        <div className="relative">
            <div
            className="accountDetailsFilter"
            style={{
                borderColor:
                showFilter === "date" ||
                    filterStartTimestamp ||
                    filterEndTimestamp
                    ? "#12ABBF"
                    : "#E6E7E9",
            }}
            onClick={(e) => {
                setShowFilter((f) => (f === "date" ? "" : "date"));
            }}
            >
            <DATE />
            <p className="accountDetailsFilterText">
                {getSelectedDateText()}
            </p>
            {showFilter === "date" ? <UP /> : <DOWN />}
            </div>
            {showFilter === "date" && (
            <DateFilter
                setShowModal={setShowFilter}
                startTimestamp={filterStartTimestamp}
                setStartTimestamp={setFilterStartTimestamp}
                endTimestamp={filterEndTimestamp}
                setEndTimestamp={setFilterEndTimestamp}
                period={datePeriod}
                setPeriod={setDatePeriod}
            />
            )}
        </div>
        <div className="relative">
            <div
            className="accountDetailsFilter"
            style={{
                borderColor:
                showFilter === "language" ||
                    (selectedLanguageFilter.languageFrom !== "" &&
                    selectedLanguageFilter.languageFrom !== "")
                    ? "#12ABBF"
                    : "#E6E7E9",
            }}
            onClick={(e) => {
                setShowFilter((f) => (f === "language" ? "" : "language"));
            }}
            >
            <LANGUAGES />
            <p className="accountDetailsFilterText">
                {getSelectedLanguage()}
            </p>
            {showFilter === "language" ? <UP /> : <DOWN />}
            </div>
            {showFilter === "language" && (
            <LanguageFilter
                setShowModal={setShowFilter}
                setSelectedLanguageFilter={setSelectedLanguageFilter}
                selectedLanguageFilter={selectedLanguageFilter}
            />
            )}
        </div>
        {teamData && teamMembers.length > 0 && (
            <div className="relative">
            <div
                className="accountDetailsFilter"
                style={{
                borderColor:
                    showFilter === "placedBy" || selectedMembers.length > 0
                    ? "#12ABBF"
                    : "#E6E7E9",
                }}
                onClick={(e) => {
                setShowFilter((f) => (f === "placedBy" ? "" : "placedBy"));
                }}
            >
                <PLACEDBY />
                <p className="accountDetailsFilterText">
                Requested By{" "}
                {selectedMembers.length > 0
                    ? ` (${selectedMembers.length}) `
                    : ""}
                </p>
                {showFilter === "placedBy" ? <UP /> : <DOWN />}
            </div>
            {showFilter === "placedBy" && (
                <Clientsfilter
                setShowModal={setShowFilter}
                clients={teamMembers}
                setSelectedClients={setSelectedMembers}
                selectedClients={selectedMembers}
                />
            )}
            </div>
        )}
        <div className="relative">
            <div
            className="accountDetailsFilter"
            style={{
                borderColor:
                showFilter === "services" || servicesFilter.length > 0
                    ? "#12ABBF"
                    : "#E6E7E9",
            }}
            onClick={(e) => {
                setShowFilter((f) => (f === "services" ? "" : "services"));
            }}
            >
            <SERVICES />
            <p className="accountDetailsFilterText">
                Services
                {/* {servicesFilter.length > 0
                ? ` (${servicesFilter.length}) `
                : ""} */}
            </p>
            {showFilter === "services" ? <UP /> : <DOWN />}
            </div>
            {showFilter === "services" && (
            <SearchFilter
                type="services"
                setStatusFilter={setServicesFilter}
                selectedFilters={servicesFilter}
                setShowModal={setShowFilter}
                isLast={teamData && teamMembers.length > 0 ? true : false}
            />
            )}
        </div>
        <div className="relative">
            <div
            className="accountDetailsFilter"
            style={{
                borderColor:
                showFilter === "status" || statusFilter !== ""
                    ? "#12ABBF"
                    : "#E6E7E9",
            }}
            onClick={(e) => {
                setShowFilter((f) => (f === "status" ? "" : "status"));
            }}
            >
            <STATUS />
            <p className="accountDetailsFilterText">
                Status{" "}
            </p>
            {showFilter === "status" ? <UP /> : <DOWN />}
            </div>
            {showFilter === "status" && (
            <SearchFilter
                quote={true}
                type="status"
                setStatusFilter={setStatusFilter}
                selectedFilters={statusFilter}
                setShowModal={setShowFilter}
                isLast={true}
            />
            )}
        </div>
        </div>

    <div className="accountDetailsScroll w-full">
        {loading ? <NoData loadingText={"quotes"} loading={true} showBtn={false} type="quote"/> :
        (!checkFetchAlgoliaData() ? localQuotes.length === 0 : hits.length === 0) && (!showSampleQuotes || (sampleQuotes && sampleQuotes.length === 0)) &&
        <NoData
        type="order"
        text={checkAnyFilterSelected() || query !== "" ? "Please select another filter" : ""}
        title={checkAnyFilterSelected() || query !== "" ? "No Quote Matching This Filter": "You Don't Have Any Active Quote Yet"}
        showBtn={!checkAnyFilterSelected() || query === ""}
        btnText={"Create Quote"}
        onClick={() => {
          transitionTo("/quote/details");
        }}
        /> }
        {((!checkFetchAlgoliaData() ? localQuotes.length > 0 : hits.length > 0) || (sampleQuotes && sampleQuotes.length > 0)) && !loading &&
        <table className="accountDetailsTable" style={{display: loading ? "none" : "table"}}>
        <thead>
            <tr>
                {showSampleQuotes && (!checkFetchAlgoliaData() ? localQuotes.length === 0 : hits.length === 0) ? <th></th> : ""}
                <th>
                <p className="accountDetailsHeading">ID</p>
                </th>
                <th>
                <div className="accountData">
                    <p className="accountDetailsHeading">Date</p>
                    { currentRefinement === "quote_time_dsc" ? 
                    <SORT_DSC className="sortIcon" onClick={() => refine("quote_time_asc")}/> 
                    : currentRefinement === "quote_time_asc" ?
                    <SORT_ASC className="sortIcon" onClick={() => refine("quote_time_dsc")}/> 
                    : <SORTBLACK className="sortIcon" onClick={() => refine("quote_time_dsc")}/>
                    }
                </div>
                </th>
                <th>
                <div className="accountData">
                    <p className="accountDetailsHeading">Languages</p>
                </div>
                </th>
                {userData && userData.teamId && (
                <th>
                    <div className="accountData">
                    <p className="accountDetailsHeading">Requested By</p>
                    { currentRefinement === "quote_name_dsc" ? 
                    <SORT_DSC className="sortIcon" onClick={() => refine("quote_name_asc")}/> 
                    : currentRefinement === "quote_name_asc" ?
                    <SORT_ASC className="sortIcon" onClick={() => refine("quote_name_dsc")}/> 
                    : <SORTBLACK className="sortIcon" onClick={() => refine("quote_name_dsc")}/>
                    }
                    </div>
                </th>
                )}
                {userData && userData.teamId && (
                <th>
                    <div className="accountData">
                    <p className="accountDetailsHeading">Client</p>
                    { currentRefinement === "quote_client_dsc" ? 
                    <SORT_DSC className="sortIcon" onClick={() => refine("quote_client_asc")}/> 
                    : currentRefinement === "quote_client_asc" ?
                    <SORT_ASC className="sortIcon" onClick={() => refine("quote_client_dsc")}/> 
                    : <SORTBLACK className="sortIcon" onClick={() => refine("quote_client_dsc")}/>
                    }
                    </div>
                </th>
                )}
                <th>
                <div className="accountData">
                    <p className="accountDetailsHeading">Services</p>
                </div>
                </th>
                <th>
                <div className="accountData">
                    {showDetailModal === "add-comment" && (
                    <div className="accountdetailHoverBox addCommentHover">
                        <p className="quotewidth">Chat</p>
                    </div>
                    )}
                    <MESSAGE
                    style={{ cursor: "pointer" }}
                    onMouseOver={() => setShowDetailModal("add-comment")}
                    onMouseLeave={() => setShowDetailModal("")}
                    />
                </div>
                </th>
                <th>
                <div className="accountData">
                    <p className="accountDetailsHeading">Status</p>
                    { currentRefinement === "quote_status_dsc" ? 
                    <SORT_DSC className="sortIcon" onClick={() => refine("quote_status_asc")}/> 
                    : currentRefinement === "quote_status_asc" ?
                    <SORT_ASC className="sortIcon" onClick={() => refine("quote_status_dsc")}/> 
                    : <SORTBLACK className="sortIcon" onClick={() => refine("quote_status_dsc")}/>
                    }
                </div>
                </th>
                <th>
                <div className="accountData">
                    <p className="accountDetailsHeading">Total</p>
                    {/* { currentRefinement === "invoice_time_dsc" ? 
                    <SORT_DSC className="sortIcon" onClick={() => refine("invoice_time_asc")}/> 
                    : currentRefinement === "invoice_time_asc" ?
                    <SORT_ASC className="sortIcon" onClick={() => refine("invoice_time_dsc")}/> 
                    : <SORTBLACK className="sortIcon" onClick={() => refine("invoice_time_dsc")}/>
                    } */}
                </div>
                </th>
                <th>
                <div className="accountData replied" style={{ justifyContent: "center"}}>
                    <p className="accountDetailsHeading">Next Step</p>
                    {/* { selectedSort === "paypalOrderID" ? 
                <SORT className="sortIcon" onClick={() => setSelectedSort("paypalOrderID")}/> 
                : <SORTBLACK className="sortIcon" onClick={() => setSelectedSort("paypalOrderID")}/>
                } */}
                    {/* { currentRefinement === "invoice_time_dsc" ? 
                    <SORT_DSC className="sortIcon" onClick={() => refine("invoice_time_asc")}/> 
                    : currentRefinement === "invoice_time_asc" ?
                    <SORT_ASC className="sortIcon" onClick={() => refine("invoice_time_dsc")}/> 
                    : <SORTBLACK className="sortIcon" onClick={() => refine("invoice_time_dsc")}/>
                    } */}
                </div>
                </th>
                <th></th>
            </tr>
            </thead>

            <TableDataComponent hits={!checkFetchAlgoliaData() ? localQuotes : hits}/>

        </table>}
            {hits.length > 0 && 
            <Pagination
            padding={0}
            showFirst={false}
            showPrevious={true}
            showNext={true}
            showLast={false}
            classNames={{
                root: "w-full my-4 mx-2",
                list: "w-full flex justify-center items-center gap-2",
                item: "",
                selectedItem:"",
                disabledItem:"opacity-50 cursor-not-allowed",
                previousPageItem: "px-4 py-1 font-medium bg-primary text-white rounded-md hover:bg-primary/70 transition",
                nextPageItem: "px-4 py-1 font-medium bg-primary text-white rounded-md hover:bg-primary/70 transition",
                firstPageItem: "px-4 py-1 font-medium bg-primary text-white rounded-md hover:bg-primary/70 transition",
                lastPageItem: "px-4 py-1 font-medium bg-primary text-white rounded-md hover:bg-primary/70 transition",
            }}
            translations={{
            previousPageItemText: 'Previous',
            nextPageItemText: 'Next',
            pageItemText: ({ currentPage, nbPages }) => `Page ${currentPage}`,
            previousPageItemAriaLabel: 'Go to previous page',
            nextPageItemAriaLabel: 'Go to next page',
            pageItemAriaLabel: ({ currentPage, nbPages }) => `Go to page ${currentPage} of ${nbPages}`,
            }}
            />}
    </div>
    
    </AccountNavBar>
    </>

)
  
};

export default AccountQuotesComponent;
